/* tslint:disable */
/* eslint-disable */
/**
 * Capture config API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export const LocalDbTypeEnum = {
    Influx: 0,
    Csv: 1,
    Mqtt: 2,
    Redis: 3,
    Influx2: 4,
    NatsJetStream: 5,
    TimescaleWide: 6,
    TimescaleNarrow: 7
};
